// Permissões do caixa por funcionário (v1.5.789). As chaves moram na mesma
// lista `allowed_modules` do usuário e precisam bater com
// backend/api/v1/auth/permissions.py. Dono e administrador podem tudo.

export const PERMISSOES_CAIXA = [
  { id: "caixa_abrir", label: "Abrir caixa", hint: "Começar o turno com o troco da gaveta" },
  { id: "caixa_fechar", label: "Fechar caixa", hint: "Contar, conferir e fechar" },
  { id: "caixa_movimentar", label: "Tirar e colocar dinheiro", hint: "Sangria e suprimento" },
];

export const CHAVES_CAIXA = PERMISSOES_CAIXA.map((p) => p.id);

/** { abrir, fechar, movimentar } a partir de uma função "pode acessar a chave?". */
export const permissoesCaixa = (pode) => ({
  abrir: pode("caixa_abrir"),
  fechar: pode("caixa_fechar"),
  movimentar: pode("caixa_movimentar"),
});
